/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.QuickbooksDesktop {
    export class MeevoMatchVerify implements angular.IDirective {
        require = 'ngModel';
        restrict = 'A';
        link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModel: any) => {            
            if (!ngModel) return;

            // watch own value and re-validate on change
            scope.$watch(attrs.ngModel, function () {
                validate();
            });

            attrs.$observe('meevoMatchVerify', function (val) {
                validate();
            });

            const validate = () => {
                const viewValue = ngModel.$viewValue;
                const matchVerify = attrs.meevoMatchVerify;

                // set validity
                ngModel.$setValidity('meevoMatchVerify', viewValue === matchVerify);
            };
        };

        constructor() { }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoMatchVerify();
            };

            return directive;
        }
    }

    angular.module("meevo.plugins.quickbooksDesktop")
        .directive("meevoMatchVerify", MeevoMatchVerify.factory());
}